import { Col, Divider, Row } from "antd";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FieldBuilder from "../../form-components/field-builder";

export const DiscountDetailsSection = ({ control }) => {
    const { t } = useTranslation();
    const typeApp = useWatch({ control, name: "typeApp" });

    const byInvitation = useWatch({
        control,
        name: "isInvitation",
    });
    const type = useWatch({
        control,
        name: "type",
    });
    const userType = useWatch({
        control,
        name: "userType",
    });
    
    return (
        <>
            <Divider orientation="center">{t("discount_details")}</Divider>
            <Row gutter={[16, 8]}>
                {(type != 1 || byInvitation || userType == 3) && <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name={"codeValidity"}
                        label={t("code_validity")}
                        input={{ type: "number" }}
                        rules={{ required: type != 1 || byInvitation || userType == 3 }}
                    />
                </Col>}
                {!byInvitation && type != 1 && <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name={"numberPoints"}
                        label={t("number_points")}
                        input={{ type: "number" }}
                        rules={{ required: type == 2 }}
                        disabled={type == 1 || byInvitation}
                    />
                </Col>}
                {!byInvitation && type == 1 && userType != 3 && <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="validityDate"
                        rules={{ required: false }}
                        label={`${t("validity_date")}`}
                        input={{ type: "date-picker", format: "YYYY-MM-DD" }}
                    />
                </Col>}

                {typeApp != 1 && <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name={"discountValueProduct"}
                        label={t("discountValueProduct")}
                        rules={{ required: typeApp != 1 ? true : false }}
                        input={{ type: "number" }}
                        disabled={typeApp == 1 ? true : false}
                    />
                </Col>}
                {typeApp != 2 && <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name={"discountValueDelivery"}
                        label={t("discountValueDelivery")}
                        input={{ type: "number" }}
                        rules={{ required: typeApp != 2 ? true : false }}
                        disabled={typeApp == 2 ? true : false}
                    />
                </Col>}
            </Row>
            <Divider orientation="center">{t("usage_limits")}</Divider>
            <Row gutter={[16, 8]}>
                <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="minimumLimit"
                        label={t("minimum_limit_coupon")}
                        input={{ type: "number" }}
                        rules={{ required: true }}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="upperLimit"
                        label={t("maximum_limit_coupon")}
                        input={{ type: "number" }}
                        rules={{ required: true }}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name={"maxOfUse"}
                        label={t("frequency_of_use")}
                        input={{ type: "number" }}
                        rules={{ required: true }}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="numberOfUseAllowed"
                        label={t("numberOfUsersAllowed")}
                        input={{ type: "number" }}
                        rules={{ required: true }}
                    />
                </Col>

            </Row>
        </>
    );
};